import Bugsnag from '@bugsnag/js'

const bugsnagApiKey = document.body.dataset.bugsnagApiKey
const bugsnagReleaseStage = document.body.dataset.bugsnagReleaseStage
if (bugsnagApiKey && bugsnagReleaseStage) {
  Bugsnag.start({
    apiKey: bugsnagApiKey,
    releaseStage: bugsnagReleaseStage,
    enabledReleaseStages: ['production', 'staging']
  })
}